<div class="py-4">
  @if (isLoading()) {
  <div class="table-responsive" data-testid="quiz-record-loading">
    <table class="table table-row-bordered align-middle gy-4">
      <thead>
        <tr class="fw-semibold fs-7 text-muted text-uppercase">
          <th>{{ "QUIZ.TITLE" | translate }}</th>
          <th class="min-w-125px">{{ "APP.DATE" | translate }}</th>
          <th class="text-center">{{ "QUIZ.SCORE" | translate }}</th>
          <th class="text-center">{{ "QUIZ.RESULT" | translate }}</th>
          <th class="text-end"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngTemplateOutlet="rowSkeleton"></ng-container>
        <ng-container *ngTemplateOutlet="rowSkeleton"></ng-container>
        <ng-container *ngTemplateOutlet="rowSkeleton"></ng-container>
        <ng-container *ngTemplateOutlet="rowSkeleton"></ng-container>
        <ng-container *ngTemplateOutlet="rowSkeleton"></ng-container>
        <ng-container *ngTemplateOutlet="rowSkeleton"></ng-container>
      </tbody>
    </table>
  </div>
  } @else if (!attempts().length) {
  <!-- Not a lone grey sentence in 480px of white. The button also says what
         pressing it does: "แบบฝึกหัด" is a noun, and a noun on a button reads
         as a label for the empty area rather than as a way out of it. -->
  <div class="empty-state" data-testid="quiz-record-empty">
    <span class="empty-state__mark">
      <app-keenicon name="note-2" class="fs-2tx"></app-keenicon>
    </span>
    <p class="empty-state__title">{{ "QUIZ.NO_HISTORY" | translate }}</p>
    <p class="empty-state__body">{{ "QUIZ.NO_HISTORY_HINT" | translate }}</p>
    <a class="btn btn-primary" routerLink="/online-class/quiz">{{ "QUIZ.GO_PRACTISE" | translate }}</a>
  </div>
  } @else {
  <div class="table-responsive" data-testid="quiz-record">
    <table class="table table-row-bordered align-middle gy-4">
      <thead>
        <tr class="fw-semibold fs-7 text-muted text-uppercase">
          <th>{{ "QUIZ.TITLE" | translate }}</th>
          <!-- Every other list in the app is dated. This one showed 26 rows
                 in an order the reader had no way to work out. -->
          <th class="min-w-125px">{{ "APP.DATE" | translate }}</th>
          <th class="text-center">{{ "QUIZ.SCORE" | translate }}</th>
          <th class="text-center">{{ "QUIZ.RESULT" | translate }}</th>
          <th class="text-end"></th>
        </tr>
      </thead>
      <tbody>
        @for (row of attempts(); track row.id) {
        <tr>
          <td>
            <span class="fs-6 fw-semibold">{{ row.quiz_title }}</span>
          </td>
          <td class="fs-7 text-muted">
            <!-- `created_at` is not in this payload at all — the API sends
                     `started_at` and `submitted_at`. The date that matters on a
                     finished paper is when it was handed in. -->
            @if (row.submitted_at || row.started_at; as when) {
            {{ when | bEDate : "dd/MM/yyyy HH:mm" }}
            }
          </td>
          <td class="text-center fs-6">{{ row.score }} / {{ row.max_score }}</td>
          <td class="text-center">
            <span class="badge" [class.badge-light-success]="row.passed" [class.badge-light-danger]="!row.passed">
              {{ row.percent }}%
            </span>
          </td>
          <td class="text-end">
            <!-- The answer key belongs to the student who sat the paper:
                     the API lets nobody else open an attempt, so offering a
                     parent the link would only ever produce "Access denied".
                     The parent gets the score and the verdict here, and the
                     skills tab for what to do about them. -->
            @if (!viewingOther()) {
            <a class="btn btn-sm btn-light" [routerLink]="['/online-class/quiz/result', row.id]">
              {{ "QUIZ.VIEW_RESULT" | translate }}
            </a>
            }
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>

<ng-template #rowSkeleton>
  <tr>
    <td>
      <div class="skeleton h-20px w-75"></div>
    </td>
    <td>
      <div class="skeleton h-20px w-125px"></div>
    </td>
    <td class="text-center">
      <div class="skeleton h-20px w-50px mx-auto"></div>
    </td>
    <td class="text-center">
      <div class="skeleton h-25px w-60px mx-auto"></div>
    </td>
    <td class="text-end">
      <div class="skeleton h-30px w-90px ms-auto"></div>
    </td>
  </tr>
</ng-template>